import { c as _c } from "react/compiler-runtime";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { AccountSettingsTabs, MainRoutes } from "@router/route-params";
import { getPreservedQueryParams } from "@router/router-helper";
import { useLocation, useNavigate } from "react-router-dom";

/** Router state marking that the tab selection was opened from a tab */

/** @returns Whether the router state marks the tab selection as opened from a tab */
function isTabSelectionState(state) {
  return typeof state === "object" && state !== null && "isOpenedFromTab" in state && state.isOpenedFromTab === true;
}

/** Custom hook to open and close the tab selection (the menu) in the mobile account settings */
export function useAccountSettingsMobileMenu() {
  const $ = _c(10);
  const navigate = useNavigate();
  const {
    search,
    state
  } = useLocation();
  const {
    navigateToAccountSettingsPage
  } = useAppNavigation();
  let t0;
  if ($[0] !== navigate || $[1] !== search) {
    t0 = function openTabSelection() {
      const tabSelectionState = {
        isOpenedFromTab: true
      };
      navigate({
        pathname: `${MainRoutes.root}${MainRoutes.accountSettings}`,
        search: getPreservedQueryParams(search)
      }, {
        state: tabSelectionState
      });
    };
    $[0] = navigate;
    $[1] = search;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const openTabSelection = t0;
  let t1;
  if ($[3] !== navigate || $[4] !== navigateToAccountSettingsPage || $[5] !== state) {
    t1 = function closeTabSelection() {
      if (isTabSelectionState(state)) {
        navigate(-1);
        return;
      }
      navigateToAccountSettingsPage(AccountSettingsTabs.security);
    };
    $[3] = navigate;
    $[4] = navigateToAccountSettingsPage;
    $[5] = state;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const closeTabSelection = t1;
  let t2;
  if ($[7] !== closeTabSelection || $[8] !== openTabSelection) {
    t2 = {
      openTabSelection,
      closeTabSelection
    };
    $[7] = closeTabSelection;
    $[8] = openTabSelection;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}